import { defineComponent as _defineComponent } from 'vue';
import { BLink, BProgress, BProgressBar } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { isRegisteredUser } from "@/api";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import { bytesToString } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuotaMeter',
    setup(__props) {
        const { config } = useConfig();
        const { currentUser, isAnonymous } = storeToRefs(useUserStore());
        const hasQuota = computed(() => {
            const quotasEnabled = config.value.enable_quotas ?? false;
            const quotaLimited = (isRegisteredUser(currentUser.value) && currentUser.value.quota !== "unlimited") ?? false;
            return quotasEnabled && quotaLimited;
        });
        const quotaLimit = computed(() => (isRegisteredUser(currentUser.value) && currentUser.value.quota) ?? null);
        const totalUsageString = computed(() => {
            const total = currentUser.value?.total_disk_usage ?? 0;
            return bytesToString(total, true);
        });
        const usage = computed(() => {
            if (hasQuota.value) {
                return currentUser.value?.quota_percent ?? 0;
            }
            return currentUser.value?.total_disk_usage ?? 0;
        });
        const quotaLink = computed(() => (isAnonymous.value ? "/login/start" : "/storage"));
        const quotaTitle = computed(() => isAnonymous.value ? "Login to Access Storage Details" : "Storage and Usage Details");
        const variant = computed(() => {
            if (!hasQuota.value || usage.value < 80) {
                return "success";
            }
            else if (usage.value < 95) {
                return "warning";
            }
            return "danger";
        });
        return { __sfc: true, config, currentUser, isAnonymous, hasQuota, quotaLimit, totalUsageString, usage, quotaLink, quotaTitle, variant, BLink, BProgress, BProgressBar };
    }
});
